import React, { useState, useEffect, Fragment, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ClassicButtonOutline } from "../../../../ButtonWithLoading";
import { Popover } from "antd";
import { GiMoneyStack } from "react-icons/gi";
import { updateOrder } from "../../../../../../redux/Actions/orderAction";
import { AiOutlineCheck, AiOutlineLeft } from "react-icons/ai";
import SendForClient from "../SmallComp/sendForClient";
import { isOrderRowCod } from "../../../../../../helpers/OrdersFunctionsGlobal";
import PopoverInvoiceChildren from "./PopoverInvoiceChildren";

const PopoverInvoiceButton = ({
  order_id,
  order_rows_info,
  shipments_info,
  invoices_info,
  order_cart_rules_info,
  carrier_info,
  assigned_bills_info,
  mode,
  order_shop_id = 0,
}) => {
  const [type, setType] = useState("");
  const dispatch = useDispatch();
  let invoices = [];
  let orderId = order_id;
  let assigned_bills = false;
  let order_rows = [];
  let shipments = [];
  let order_shopId = order_shop_id;

  if (order_id) {
    invoices =
      mode == "pre_invoice"
        ? invoices_info.filter(
          (e) => e.invoice_number?.startsWith("IS") || e.identifier !== null
        )
        : invoices_info.filter(
          (e) => !e.invoice_number?.startsWith("IS") && e.identifier == null
        );
    orderId = order_id;
    order_shopId = order_shop_id;
    assigned_bills = assigned_bills_info;
    order_rows = order_rows_info;
    shipments = shipments_info;
  } else {
    const {
      invoices: invoices_redux,
      order: {
        id: order_redux,
        assigned_bills: assigned_bills_redux,
        order_shop_id: order_shop_id_redux,
      },
      order_rows: order_rows_redux,
      shipments: shipments_redux,
    } = useSelector((state) => state.orders);
    invoices =
      mode == "pre_invoice"
        ? invoices_redux.filter(
          (e) => e.invoice_number?.startsWith("IS") || e.identifier !== null
        )
        : invoices_redux.filter(
          (e) => !e.invoice_number?.startsWith("IS") && e.identifier == null
        );
    orderId = order_redux;
    assigned_bills = assigned_bills_redux;
    order_rows = order_rows_redux;
    shipments = shipments_redux;
    order_shopId = order_shop_id_redux;
  }

  const [partialInvoice, setPartialInvoice] = useState({
    error: null,
    loading: false,
    children_loading: false,
  });

  const isCompleted = useMemo(() => {
    const written_in_invoices = invoices
      .filter(({ invoice_number }) => !invoice_number?.startsWith("IS"))
      .map(({ identifier, order_invoice_order_rows }) => {
        if (mode == "pre_invoice") {
          if (identifier !== "pre_invoice") return [];
        } else {
          if (identifier == "pre_invoice") return [];
        }

        return order_invoice_order_rows
          .filter(
            ({ api_error }) =>
              !api_error &&
              (mode !== "pre_invoice" ? identifier === null : true)
          )
          .map(({ order_row_id }) => order_row_id);
      })
      .flat();

    const must_be_written = order_rows
      .filter(({ id_product }) => !isOrderRowCod(id_product, order_shopId))
      .map(({ id }) => id);

    return must_be_written.every((order_row_id) =>
      written_in_invoices.includes(order_row_id)
    );
  }, [invoices.length, order_rows.length]);

  useEffect(() => {
    if (!isCompleted) return;
    if (assigned_bills) return;
    const updateOrderAsync = async () => {
      await dispatch(
        updateOrder(orderId, {
          assigned_bills: true,
        })
      );
    };
    updateOrderAsync();
  }, [isCompleted]);

  const title_string = useMemo(
    () =>
      mode == "pre_invoice"
        ? `Proforma invoice (${invoices.filter(
          (e) => e.invoice_number?.startsWith("IS") || e.identifier !== null
        ).length
        })`
        : `Invoices (${invoices.filter(
          (e) => !e.invoice_number?.startsWith("IS") && e.identifier == null
        ).length
        })`,
    [mode, invoices.length]
  );
  return (
    <div className="mr-3">
      <Popover
        placement="left"
        title={
          <div
            className="d-flex align-items-center justify-content-between py-2 "
            style={{
              minWidth: 407,
            }}
          >
            {type == "send_for_client" ? (
              <div
                className="cursor-pointer d-flex align-items-center justify-content-center"
                onClick={() => setType("")}
              >
                <AiOutlineLeft className="text-xl" />
                <span className="text-sm font-semi-bold text-black">Back</span>
              </div>
            ) : (
              <React.Fragment>
                <div className="font-semi-bold">{title_string}</div>
                <button
                  className="btn btn-outline-secondary text-xs px-4"
                  onClick={() => {
                    if (mode == "pre_invoice") {
                      document.querySelector(".generate_inv").click();
                      console.log("CLICKED! ");
                      return;
                    }

                    setType("send_for_client");
                  }}
                >
                  Send {mode == "pre_invoice" ? "to" : "for"} client
                </button>
              </React.Fragment>
            )}
          </div>
        }
        open={partialInvoice.loading}
        onOpenChange={(loading) =>
          setPartialInvoice({
            ...partialInvoice,
            loading,
            children_loading: false,
          })
        }
        content={
          <div
            style={{
              minWidth: 407,
            }}
          >
            {type == "send_for_client" ? (
              <SendForClient order_id={orderId} setType={setType} />
            ) : partialInvoice.loading ? (
              <PopoverInvoiceChildren
                setPartialInvoice={setPartialInvoice}
                shipments={shipments}
                invoices={invoices}
                partialInvoice={partialInvoice}
                order_rows={order_rows.filter(
                  (order_row) =>
                    !isOrderRowCod(order_row.id_product, order_shopId)
                )}
                order_cart_rules_info={order_cart_rules_info}
                carrier_info={carrier_info}
                order_id={order_id}
                mode={mode}
                show_checkbox={![1, 4].includes(order_shopId)}
                real_order_id={orderId}
              />
            ) : (
              ""
            )}
          </div>
        }
        trigger="click"
      >
        {!isCompleted ? (
          <ClassicButtonOutline loading={partialInvoice.loading}>
            <GiMoneyStack size={16} />
            <span className="ml-2">{title_string}</span>
          </ClassicButtonOutline>
        ) : (
          <button
            className="btn btn-sm btn-outline-success d-flex justify-content-center align-items-center"
            style={{ minWidth: "50px", maxWidth: "150px", height: "30px" }}
          // disabled={true}
          >
            {partialInvoice.loading ? (
              <>
                <span className="spinner-border spinner-border-sm"></span>
                <span> In progress...</span>
              </>
            ) : (
              <>
                <AiOutlineCheck size={16} />
                <span className="ml-2">{title_string}</span>
              </>
            )}
          </button>
        )}
      </Popover>
      {partialInvoice.error && (
        <div className="text-danger small">{partialInvoice.error}</div>
      )}
    </div>
  );
};

export default PopoverInvoiceButton;
